(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE')
        return;




      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form)
        form.submit();




    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jobs-listing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.jobs').forEach(function (scope) {
    var list = scope.querySelector('[data-jobs-list]');
    if (!list) return;

    var items = Array.prototype.slice.call(scope.querySelectorAll('[data-job]'));
    if (!items.length) return;

    var toolbar = scope.querySelector('[data-jobs-toolbar]');
    var countEl = scope.querySelector('[data-jobs-count]');
    var noneEl = scope.querySelector('[data-jobs-none]');
    var chips = Array.prototype.slice.call(scope.querySelectorAll('[data-chip]'));
    var clearButtons = Array.prototype.slice.call(scope.querySelectorAll('[data-jobs-clear]'));
    var selects = {
      branch: scope.querySelector('[data-filter="branch"]'),
      role: scope.querySelector('[data-filter="role"]')
    };
    var region = '';

    // Urgent first, then the merchant's sort order, then location.
    // Sorted here because Liquid's `sort` cannot reach a value nested inside a
    // metaobject field and would fail silently if asked to.
    items
      .sort(function (a, b) {
        if (a.dataset.urgent !== b.dataset.urgent) {
          return b.dataset.urgent.localeCompare(a.dataset.urgent);
        }
        var sa = parseInt(a.dataset.sort, 10);
        var sb = parseInt(b.dataset.sort, 10);
        if (sa !== sb) return sa - sb;
        return (a.dataset.branch || '').localeCompare(b.dataset.branch || '', 'he');
      })
      .forEach(function (li) { list.appendChild(li); });

    function fill(select, values) {
      if (!select) return;
      var placeholder = select.firstElementChild;
      select.textContent = '';
      select.appendChild(placeholder);
      values
        .sort(function (a, b) { return a.localeCompare(b, 'he'); })
        .forEach(function (v) {
          var o = document.createElement('option');
          o.value = v;
          o.textContent = v;
          select.appendChild(o);
        });
    }

    function uniq(key, pool) {
      var seen = {};
      (pool || items).forEach(function (li) {
        if (li.dataset[key]) seen[li.dataset[key]] = true;
      });
      return Object.keys(seen);
    }

    function inRegion() {
      return region ? items.filter(function (li) { return li.dataset.region === region; }) : items;
    }

    // Offer only branches and roles that actually have an opening in the chosen region.
    function refreshSecondary() {
      var pool = inRegion();
      ['branch', 'role'].forEach(function (k) {
        var sel = selects[k];
        if (!sel) return;
        var current = sel.value;
        fill(sel, uniq(k, pool));
        var kept = Array.prototype.some.call(sel.options, function (o) { return o.value === current; });
        sel.value = kept ? current : '';
      });
    }

    function paintChipCounts() {
      chips.forEach(function (chip) {
        var key = chip.dataset.chip;
        var n = key
          ? items.filter(function (li) { return li.dataset.region === key; }).length
          : items.length;
        var slot = chip.querySelector('[data-chip-count]');
        if (slot) slot.textContent = n;
      });
    }

    function syncUrl() {
      var params = new URLSearchParams(window.location.search);
      var map = { region: region, branch: selects.branch ? selects.branch.value : '', role: selects.role ? selects.role.value : '' };
      Object.keys(map).forEach(function (k) {
        if (map[k]) { params.set(k, map[k]); } else { params.delete(k); }
      });
      var qs = params.toString();
      history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : ''));
    }

    function apply() {
      var branch = selects.branch ? selects.branch.value : '';
      var role = selects.role ? selects.role.value : '';
      var count = 0;

      items.forEach(function (li) {
        var ok =
          (!region || li.dataset.region === region) &&
          (!branch || li.dataset.branch === branch) &&
          (!role || li.dataset.role === role);
        li.hidden = !ok;
        if (ok) count++;
      });

      chips.forEach(function (chip) {
        chip.classList.toggle('is-active', chip.dataset.chip === region);
        chip.setAttribute('aria-pressed', chip.dataset.chip === region ? 'true' : 'false');
      });

      if (countEl) {
        countEl.textContent = count === items.length
          ? count + (count === 1 ? ' משרה פתוחה' : ' משרות פתוחות')
          : count + ' מתוך ' + items.length + ' משרות';
      }
      if (noneEl) noneEl.hidden = count !== 0;

      var filtering = Boolean(region || branch || role);
      clearButtons.forEach(function (b) {
        if (b.closest('[data-jobs-toolbar]')) b.hidden = !filtering;
      });

      syncUrl();
    }

    function reset() {
      region = '';
      if (selects.branch) selects.branch.value = '';
      if (selects.role) selects.role.value = '';
      refreshSecondary();
      apply();
    }

    fill(selects.role, uniq('role'));

    // Restore a shared or bookmarked filter state.
    var incoming = new URLSearchParams(window.location.search);
    var wantRegion = incoming.get('region');
    if (wantRegion && chips.some(function (c) { return c.dataset.chip === wantRegion; })) {
      region = wantRegion;
    }
    refreshSecondary();
    if (selects.branch && incoming.get('branch')) selects.branch.value = incoming.get('branch');
    if (selects.role && incoming.get('role')) selects.role.value = incoming.get('role');

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        region = chip.dataset.chip;
        refreshSecondary();
        apply();
      });
    });
    if (selects.branch) selects.branch.addEventListener('change', apply);
    if (selects.role) selects.role.addEventListener('change', apply);
    clearButtons.forEach(function (b) { b.addEventListener('click', reset); });

    paintChipCounts();
    if (toolbar) toolbar.hidden = false;
    apply();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-branches"]) return;
  try {
    
  class StoreLocator extends HTMLElement {
    constructor() {
      super();
      this.locatorActions = this.querySelector('template').content;
      this.locatorActions.select = this.locatorActions.querySelector('select');
      let optionsHtml = '';
      document.querySelectorAll('.storegroupd-title').forEach((storeGroup) => {
        optionsHtml += `<option value="${storeGroup.id}">${storeGroup.id.replace('-', ' ')}</option>`;
      });
      this.locatorActions.select.innerHTML += optionsHtml;
      document.querySelector('.shopify-section.storelocator').after(this.locatorActions);
      this.scrollContainer = document.querySelector('.page-storelocator');
      this.mql = window.matchMedia('(min-width: 750px)');
      this.locatorActions.select.addEventListener('change', this.onChange.bind(this));
    }

    onChange(event) {
      const value = event.target.value;

      if (value) {
        location.hash = value;
      }
    }
  }
  customElements.define('store-locator', StoreLocator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
